import './PresenceWarningBanner.css';

function PresenceWarningBanner({ users = [], onDismiss }) {
    if (!users || users.length === 0) return null;

    const label = users.map((u) => u.name || u.email).join(", ");
    const verb = users.length > 1 ? "are" : "is";

    return (
        <div className="presence-warning-banner">
            <i className="fas fa-triangle-exclamation presence-warning-banner_icon"></i>
            <span>Warning - {label} {verb} currently viewing or editing this conversation</span>
            <i className="fas fa-times presence-warning-banner_close" onClick={onDismiss} title="Dismiss"></i>
        </div>
    );
}

export default PresenceWarningBanner;
